import { render } from "./GenreFilterView.vue?vue&type=template&id=3d3a5230&scoped=true"
import script from "./GenreFilterView.vue?vue&type=script&lang=js"
export * from "./GenreFilterView.vue?vue&type=script&lang=js"

import "./GenreFilterView.vue?vue&type=style&index=0&id=3d3a5230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3a5230"]])

export default __exports__